import ListContentLayout from 'layout/ListContentLayout'
import React, { FC } from 'react'
import { PropertyList } from 'components/shared/Property'
import useFetchListing from 'hooks/useFetchListing'
import { BtnAnch } from 'components/elements/global'
import { ADMIN_PREFIX_PATH } from 'config'
import { useNavigate } from 'react-router'
import useCheckModule from 'hooks/useCheckModule'
import ProListingActionBlock from '../components/ProListingActionBlock'
import ProListingHeader from '../components/ProListingHeader'
import { TPropertyListing } from '../types'
import { useProListing } from '../provider/ProListingProvider'

const PreConListing: FC = () => {
 const { filterParams } = useProListing()
 const navigate = useNavigate()
 const { checkIsModule } = useCheckModule()

 const { flatData, isLoading, fetchMore, hasMore } =
  useFetchListing<TPropertyListing>('get-pre-condos', {
   params: `api_version=v3&${filterParams}`,
   listingType: 'preconstruction',
  })
 return (
  <ListContentLayout
   actions={<ProListingActionBlock />}
   //    title="Pre-Construction Listings"
   title={
    <>
     Pre-Construction Listings{' '}
     {/* Settings shortcut only when Listing Settings module is enabled */}
     {checkIsModule('settings_listing_settings') && (
      <BtnAnch
       onClick={() =>
        navigate(`${ADMIN_PREFIX_PATH}/settings/listing-settings`)
       }
       tooltipText="Listing Settings"
      >
       <i className="fas fa-cog" />
      </BtnAnch>
     )}
    </>
   }
  >
   <div className="prolisting-page">
    <ProListingHeader type="precon" />
    <PropertyList
     data={flatData}
     fetchMore={fetchMore}
     hasMore={hasMore}
     isLoading={isLoading}
     selection
     isPreCon
    />
   </div>
  </ListContentLayout>
 )
}

export default PreConListing
